// extracted by mini-css-extract-plugin
export default {"planetMint":"PlanetMintWithRocks_planetMint__yST8s"};